// API helpers per notifiche "cliente da assegnare" + gestione multi-membro.
// Utilizzati dal widget dashboard e dall'editor inline della scheda cliente.
import { api } from "@/lib/api";

/** Lista notifiche non lette di tipo `client_to_assign` con dati arricchiti. */
export const listPendingAssignments = () =>
  api.get("/administration/pending-assignments").then((r) => r.data);

/** Team attualmente assegnato a un cliente (dal source of truth). */
export const getClientTeam = (clientId) =>
  api.get(`/clients/${clientId}/team`).then((r) => r.data);

/** Aggiunge uno o più membri del team all'assegnazione del cliente (idempotente). */
export const addClientAssignees = (clientId, userIds, roleOnClient = "manager") =>
  api.post(`/clients/${clientId}/assignees`, { user_ids: userIds, role_on_client: roleOnClient })
    .then((r) => r.data);

/** Rimuove un membro dall'assegnazione del cliente. */
export const removeClientAssignee = (clientId, userId) =>
  api.delete(`/clients/${clientId}/assignees/${userId}`).then((r) => r.data);

// Auto-gestione: il membro si aggiunge/rimuove da solo (nessun permesso speciale).
export const selfJoinClient = (clientId) =>
  api.post(`/clients/${clientId}/assignees/self`).then((r) => r.data);
export const selfLeaveClient = (clientId) =>
  api.delete(`/clients/${clientId}/assignees/self`).then((r) => r.data);

/** Marca una notifica come letta (dismiss dal widget verde). */
export const dismissNotification = (notificationId) =>
  api.patch(`/administration/notifications/${notificationId}/read`).then((r) => r.data);

/** Notifiche di assegnazione cliente per l'utente corrente (banner globale). */
export const listAssignmentNotifications = () =>
  api.get("/assignment-notifications").then((r) => r.data);

/** Prende visione di una singola notifica di assegnazione (dismiss dal banner). */
export const ackAssignmentNotification = (nid) =>
  api.post(`/assignment-notifications/${nid}/ack`).then((r) => r.data);

/** Prende visione di tutte le notifiche di assegnazione. */
export const ackAllAssignmentNotifications = () =>
  api.post("/assignment-notifications/ack-all").then((r) => r.data);
